import React from "react";
import { api } from "@/lib/api";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    try {
      api.post("/logs/ui", {
        message: String(error?.message || error).slice(0, 500),
        stack: String(error?.stack || "").slice(0, 1500),
        url: window.location.href,
        user_agent: navigator.userAgent,
        meta: {
          component_stack: String(info?.componentStack || "").slice(0, 800),
          viewport: `${window.innerWidth}x${window.innerHeight}`,
          language: navigator.language,
        },
      }).catch(() => {});
    } catch (_) {
      /* noop */
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-[#FDFBF7] text-[#1C1917] px-6 text-center" data-testid="error-boundary-fallback">
          <div className="font-display text-4xl mb-4">Ups, ada kendala teknis 🙏</div>
          <p className="text-stone-600 max-w-md mb-8">
            Tim kami sudah menerima laporan otomatis. Silakan muat ulang halaman.
          </p>
          <button
            data-testid="error-boundary-reload"
            onClick={() => window.location.reload()}
            className="px-7 py-3.5 bg-[#0A0A0A] text-white hover:bg-[#F39237] hover:text-[#0A0A0A] transition-colors"
          >
            Muat Ulang
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
